import React from 'react';
import { Container, Button } from '../design-system';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { trackEvent } from '../utils/analytics';

interface CTAProps {
  onContactClick: () => void;
}

export function CTA({ onContactClick }: CTAProps) {
  const { t } = useI18n();
  return (
    <section className="py-20 bg-gradient-to-br from-indigo-600 to-purple-600 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      
      <Container maxWidth="xl">
        <div className="relative text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            {t('cta.heading')}
          </h2>
          <p className="text-xl text-indigo-100 mb-10 max-w-3xl mx-auto">
            {t('cta.description')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              variant="secondary"
              onClick={() => { trackEvent('cta_click', { location: 'cta_primary' }); onContactClick(); }}
            >
              <MessageCircle className="w-5 h-5" />
              {t('cta.primary')}
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-indigo-600"
              onClick={() => trackEvent('cta_click', { location: 'cta_secondary' })}
            >
              {t('cta.secondary')}
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>

        </div>
      </Container>
    </section>
  );
}
